import {Component, OnInit} from '@angular/core';
import {Location, NgOptimizedImage} from '@angular/common';
import {DeprecatedSharedUtilsModule} from '../../utils/deprecated-shared-utils-module';
import {UiModule} from '../../utils/ui/ui.module';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    imports: [
        DeprecatedSharedUtilsModule,
        NgOptimizedImage,
        UiModule
    ],
    styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

   constructor(public location: Location) {
   }

   ngOnInit() {
   }

}
